import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DeliverySort, deliverySortKey } from './delivery-sort.reducer';

export const selectDeliverySort = createFeatureSelector<DeliverySort>(deliverySortKey);

export const getField = createSelector(
  selectDeliverySort,
  (state: DeliverySort) => state.fieldName,
);

export const getOrder = createSelector(selectDeliverySort, (state: DeliverySort) => state.sortType);

export const getUnreadValue = createSelector(
  selectDeliverySort, (state: DeliverySort) => state && state.viewBy,
);
